import * as Sentry from '@sentry/react';
import { Toaster } from 'sonner';
import { AppProviders } from '@app/providers/AppProviders';
import { AppRoutes } from '@app/routes';

import type { JSX } from "react";

function FallbackError(): JSX.Element {
  return (
    <div role="alert" className="p-8">
      <h1 className="text-xl font-semibold">Something went wrong.</h1>
      <p className="mt-2 text-muted-foreground">
        Please reload the page. If the problem persists, contact support.
      </p>
    </div>
  );
}

export function App(): JSX.Element {
  return (
    <AppProviders>
      <Sentry.ErrorBoundary fallback={<FallbackError />}>
        <AppRoutes />
        <Toaster position="top-right" richColors closeButton />
      </Sentry.ErrorBoundary>
    </AppProviders>
  );
}
